import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import OutgoingSidebar from "../CommonComponents/OutgoingSidebar";
import MainContent from "./OutgoingComponents/MainContent";
import { FaBars, FaTimes } from "react-icons/fa";
import RollIdPrompt from "../CommonComponents/RollIdPrompt";
import { RollIdProvider } from "../CommonComponents/RollIdContext"; // Import the provider
import Tabs from "../CommonComponents/Tabs";

const OutgoingDashboard = () => {
  const navigate = useNavigate();
  const { userType } = useParams(); // Get the user type from the URL
  console.log("User Type:", userType);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [reload, setReload] = useState(0);
  const [rollId, setRollId] = useState("");

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleRollIdSubmit = (id) => {
    setRollId(id);
  };

  useEffect(() => {
    let userTypeStorage = localStorage.getItem("user_Type");
    if (!userType || (userType !== "hgo" && userType !== "monazam")) {
      // Redirect to an error page or a default page if the userType is invalid
      navigate("/");
    } else if (userType.toLowerCase() !== userTypeStorage.toLowerCase()) {
      navigate("/error_page");
    }
  }, [userType, navigate]);
  return (
    <RollIdProvider>
      {/* Wrap everything inside the RollIdProvider */}
      <div className="dashboard-layout d-flex">
        <OutgoingSidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          relaod={reload}
          setReload={setReload}
        />

        <div className={`main-content ${isSidebarOpen ? "blurred" : ""}`}>
          {/* Hamburger Menu for mobile screens */}
          <div className="d-md-none d-flex align-items-center sidebar-logo-bg py-3 px-1">
            <button className="btn" onClick={toggleSidebar}>
              {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>

            <img
              src="/assets/logo.png"
              alt="Logo"
              className="img-fluid logo pe-5"
              style={{ height: "40px" }}
            />
          </div>

          <RollIdPrompt onRollIdSubmit={handleRollIdSubmit} />
          <div className="me-3 mt-3">
            <Tabs />
          </div>
          <MainContent reload={reload} />
        </div>
      </div>
    </RollIdProvider>
  );
};

export default OutgoingDashboard;
